import type {
  UniversalSearchHeaderRequestBody,
  UniversalSearchHeaderResponse,
  UniversalSearchTabInfo,
  UniversalSearchTabItemInfo,
} from '@weberus/shared-types';

import { atom } from 'jotai';
import {
  globalFilterParamsAtom,
  searchFilterKeywordAtom,
  searchFilterSortAtom,
} from '@/app/_shared/store/search-filter';
import {
  capacityAdultAtom,
  capacityChildAgesAtom,
  checkInDateAtom,
  checkOutDateAtom,
} from '@/app/_shared/store/local-accommodation';
import { globalCheckIOCapacityAtom } from '@/app/_shared/store/global-accommodation';
import { localLocationAtom } from '@/app/_shared/store/location';

// export const categoryAtom = atom<keyof typeof CATEGORY_TYPE>('LOCAL_ACCOMMODATION');
export const selectedVerticalTabInfoAtom = atom<UniversalSearchTabItemInfo>();
export const verticalTabInfoAtom = atom<UniversalSearchTabInfo['items']>();

/** [getter] SearchRequestParams 계산된 상태 */
export const universalHeaderReqBodyAtom = atom((get) => {
  const keyword = get(searchFilterKeywordAtom);
  const tab = get(selectedVerticalTabInfoAtom);
  const filters = get(globalFilterParamsAtom);
  const sort = get(searchFilterSortAtom);
  const checkInDate = get(checkInDateAtom);
  const checkOutDate = get(checkOutDateAtom);
  const capacityAdults = get(capacityAdultAtom);
  const childrenAges = get(capacityChildAgesAtom);
  const globalCheckIOCapacity = get(globalCheckIOCapacityAtom);
  const localLocation = get(localLocationAtom);

  return {
    keyword,
    filters: filters || [],
    category: tab?.key || 'LOCAL_ACCOMMODATION',
    sort: sort || 'RECOMMEND',
    userLocation: {
      latitude: Number(localLocation?.latitude),
      longitude: Number(localLocation?.longitude),
      locationType: localLocation?.locationType,
      locationTime: localLocation?.locationTime,
    },
    localAccommodation: {
      checkInDate,
      checkOutDate,
      capacityAdults,
      childrenAges,
    },
    globalAccommodation: {
      checkInDate: globalCheckIOCapacity.checkInDate,
      checkOutDate: globalCheckIOCapacity.checkOutDate,
      rooms: globalCheckIOCapacity.capacityRooms.map((room) => ({
        capacityAdults: room.adult,
        childrenAges: room.child,
      })),
    },
  } as UniversalSearchHeaderRequestBody;
});

export const universalSearchRequestBodyAtom = atom<UniversalSearchHeaderResponse['request'] | undefined | null>();
